var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.web)?_c('div',{staticClass:"side-right w210 pull-right",on:{"click":_vm.adUrl}},[_c('img',{attrs:{"src":_vm.web.ad||''}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }